import React, { useContext, useState } from 'react'
import { nanoid } from 'nanoid';

import { format, isValid} from "date-fns";
import { ka } from "date-fns/locale";

import DataContext from '../../context/dataContext';
import PortalContext from '../../context/portalContext';

import {CommentList} from './styled';
import { arrThickSvg, deleteSvg, thumbDown, thumbUp } from '../../svgs';
import { useRateComment, useDeleteComment } from '../../apiHooks/details';


const Comments:React.FC<any> = ({comments, slug}) => {

  const { auth, user} = useContext(DataContext);
  const { openLogin} = useContext(PortalContext);


    const locales = { ka };
    const [fullView, setFullView] = useState(false);
    const [activePk, setActivePk] = useState(null);
    const [type, setType] = useState("");


    
    // rate commment 
    const { rateComment } = useRateComment();

    const handleRateComent = (pk,reacts, value) => {
        if(!auth) return openLogin();

        const params = {
            like: value === "like" && !reacts.like ?  true:  false,
            dislike: value === "dislike" && !reacts.dislike ? true :  false,
            user: user.email,
            comment: pk,
            slug: slug,
          }
        rateComment( params);
        setActivePk(pk);
        setType(value);
        setTimeout(()=> {
            setActivePk(null);
        }, 500)
    };

    const { deleteComment} = useDeleteComment();

    const handleDelete = (pk) => {
        const params = {
            user: user.email,
            pk: pk,
            slug: slug,
          }
          deleteComment( params);

    }

    return (
        <CommentList full={fullView}>
            <div className="list">
                {comments.map( com => (
                    <div className="comment" key={com.user + com.pk}>
                        <div className='name' >{com.username}</div>
                        <div className="time">
                            {isValid(new Date(com.record_date)) ? format(new Date(com.record_date), "d/MM/yyyy", { locale: locales.ka } ) : (
                                com.record_date
                            )}
                        </div>
                        <p>{com.text}</p>
                        <div className="rate" >
                            <div className={`like ${com.reacts.like ? "liked": ""}`}  >
                                <button onMouseUp={()=> handleRateComent(com.pk, com.reacts, "like")}
                                className={`${activePk === com.pk && type ==="like" ? "loader": ""}`} >{thumbUp()}</button>
                                {com.likes}
                            </div>
                            <div className={`like dislike ${com.reacts.dislike ? "disliked": ""}`} >
                                <button onMouseUp={()=> handleRateComent(com.pk, com.reacts, "dislike")}
                                className={`${activePk === com.pk && type ==="dislike" ? "loader": ""}`} >{thumbDown()}</button>
                                {com.dislikes}
                            </div>

                            {user.username === com.username && (
                                <button onMouseUp={()=> handleDelete(com.pk)} className='delete' >{deleteSvg()}</button>
                            )}
                        </div>
                    </div>
                ))}
            </div>
            {comments.length > 2 ?<button className={`show-all ${fullView? "up": ""}`} 
                onMouseUp={() => setFullView(!fullView)} >
                მაჩვენე {fullView? "ნაკლები" : "ყველა"} {arrThickSvg()}
            </button>: null}
        </CommentList>
    )
};
export default Comments;
